import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import Filter from "components/global/Filter/Filter";
import { FilterItemTypes } from "configs/types";
import gridIcon from "assets/icons/grid-icon.svg";

type ActiveItem = { value: number | string; label: string };

interface Props {
  onApply: (params: { search: string; active?: number }) => void;
}

const PagesFilter: React.FC<Props> = ({ onApply }) => {
  const { t } = useTranslation();

  const [search, setSearch] = useState("");
  const [active, setActive] = useState<ActiveItem[]>([]);

  const handleApply = () => {
    onApply({
      search,
      active:
        active[0] && active[0].value !== 3
          ? (active[0].value as number)
          : undefined,
    });
  };

  const handleClear = () => {
    setSearch("");
    setActive([{ value: 3, label: "All" }]);
    onApply({ search: "", active: undefined });
  };

  return (
    <Filter
      handleClear={handleClear}
      handleApply={handleApply}
      filterItems={[
        {
          type: FilterItemTypes.input,
          title: t("title"),
          boxTitle: t("title"),
          icon: gridIcon,
          inputValue: search,
          setInputValue: setSearch,
          inputPlaceholder: t("title"),
          inputType: "text",
        },
        {
          type: FilterItemTypes.radio,
          title: t("isActive"),
          boxTitle: t("isActive"),
          icon: gridIcon,
          itemsArray: [
            { label: "Active", value: 1 },
            { label: "Inactive", value: 0 },
            { label: "All", value: 3 },
          ],
          activeItems: active,
          handleApply: setActive,
        },
      ]}
    />
  );
};

export default PagesFilter;
